import React, { Component } from "react";

import $ from "jquery/dist/jquery.js";
import * as apiConstant from "../../api/apiConstant";
import { Link } from "react-router-dom";
import { lang } from "../../config/lang";
import { connect } from "react-redux";
import logApi from "../../api/logApi";
/****************************************
    Component for activity block 
    @author  UYM
    @date    2020.05.13
    @version 0.1    
 ******************************************/
class ActivityBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.ellipsisStyle = this.ellipsisStyle.bind(this);
    this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    window.checkSize();
    window.playVideo();
    setTimeout(this.ellipsisStyle, 600);
    window.addEventListener("resize", this.waitAndEllipsis);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.waitAndEllipsis);
  }

  componentDidUpdate() {
    window.checkSize();
    window.playVideo();
    setTimeout(this.ellipsisStyle, 600);
  }

  componentWillReceiveProps(newProps) {}

  onErrorLoadImage(e) {
    $(e.target).attr("src", "/assets/images/no_image.png");
  }

  ellipsisStyle() {
    window.ellipsisMe("#activity_" + this.props.id);
  }

  waitAndEllipsis() {
    setTimeout(this.ellipsisStyle, 800);
  }

  render() {
    return (
      <div className="project">
        <Link to={`/activity/${this.props.id}`}>
          <div className="img">
            {(this.props.image === undefined || this.props.image === null) && (
              <img
                alt="no-image"
                className="ftco-animate fadeIn ftco-animated"
                src="/assets/images/no_image.png"
              />
            )}
            {this.props.image !== undefined &&
              this.props.image !== null &&
              this.props.mediaType === 0 && (
                <img
                  src=""
                  alt="activity"
                  onError={(e) => this.onErrorLoadImage(e)}
                  className="img-fluid a bgDiv"
                  data-desktop-image={apiConstant.thumbnail(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  data-tablet-image={apiConstant.tablet(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  data-mobile-image={apiConstant.mobile(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                />
              )}
            {this.props.image !== undefined &&
              this.props.image !== null &&
              this.props.mediaType === 1 && (
                <img
                  src={apiConstant.thumbnail(
                    this.props.business,
                    this.props.id,
                    this.props.image.split(".")[0] + ".jpg"
                  )}
                  alt="activity-block"
                  onError={(e) => this.onErrorLoadImage(e)}
                  className="img-fluid a bgDiv"
                />
              )}
          </div>
        </Link>
        {this.props.image !== undefined &&
          this.props.image !== null &&
          this.props.mediaType === 1 && (
            <a
              href={apiConstant.desktop(
                this.props.business,
                this.props.id,
                this.props.image
              )}
              className="play-video video-icon"
              onClick={() =>
                logApi.log({
                  title: this.props.title,
                  lang: localStorage.getItem("language"),
                  type: "동화상",
                })
              }
            >
              <i className="fa fa-play" aria-hidden="true"></i>
            </a>
          )}
        <div className="text">
          <Link to={`/activity/${this.props.id}`}>
            <h3
              className="ellipsis-title"
              id={`activity_${this.props.id}`}
              caption={this.props.title}
              dangerouslySetInnerHTML={{
                __html:
                  this.props.title === "" || this.props.title === null
                    ? lang("other")
                    : this.props.title,
              }}
            />
          </Link>
          <div className="star d-flex clearfix">
            <div className="mr-auto float-left"></div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(ActivityBlock);
